export const contactArray = [
    {
        icon: 'fa fa-map-marker',
        title: 'Address',
        text: 'Solar system, planet Earth'
    },
    {
        icon: 'fa fa-envelope-open',
        title: 'Address',
        text: 'philipsxenium93@gmail.com'
    },
    {
        icon: 'fa fa-phone',
        title: 'Telephone',
        text: '+66 65 335 62 63'
    },
]